export function extractTextFromHTML(s) {
	let node = document.createElement('span');
	node.innerHTML = s;
	node = node?.textContent || node?.innerText || '';
	return node.replaceAll('\n', '').trim();
}
